// import * as bootstrap from 'bootstrap'
import Modal from 'bootstrap/js/dist/modal'
import { inputElements, maskElements, tagifyElements } from './app.js'
import { map } from './constants.js'
import { signIn, signOutUser } from './server/firebase.js'
const emailInput = document.getElementById("loginMail")
const passwordInput = document.getElementById("loginPassword")
const loginBtn = document.getElementById("loginBtn")
emailInput.addEventListener("input", validateForm)
passwordInput.addEventListener("input", validateForm)
const spinner = loginBtn.querySelector('span.spinner-border')
export async function login(e, form) {
  e.preventDefault()
  e.stopPropagation()

  const emailEl = form.loginMail
  const passwordEl = form.loginPassword
  const isValidEmail = validateEmail(emailEl)
  const isValidPassword = validatePassword(passwordEl)

  if (!isValidEmail || !isValidPassword) {
    enableLoginBtn()
    console.error('Введите корректные данные')
  } else {
    const mail = emailEl.value.trim()
    const password = passwordEl.value.trim()
    const user = await signIn(mail, password)
    if (user) {
      console.log('Логин успешен:', user.email)
      return user
    } else {
      console.error('Логин неудачен')
      enableLoginBtn()
      updateValidationState(emailEl, false, '')
      updateValidationState(passwordEl, false, 'Неправильная почта или пароль')
    }
  }
}

function isEmailValid(email) {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/
  return emailRegex.test(email)
}

function validateForm() {
  const isEmailValid = validateEmail(emailInput)
  const isPasswordValid = validatePassword(passwordInput)
  loginBtn.disabled = !(isEmailValid && isPasswordValid)
  return isEmailValid && isPasswordValid
}

function validateEmail(emailInput) {
  const email = emailInput.value.trim()
  if (!email) {
    updateValidationState(emailInput, false, "Введите почту")
    return false
  } else if (!isEmailValid(email)) {
    updateValidationState(emailInput, false, "Введите почту в правильном формате")
    return false
  } else {
    updateValidationState(emailInput, true)
    return true
  }
}

function validatePassword(passwordInput) {
  const password = passwordInput.value.trim()
  if (!password) {
    updateValidationState(passwordInput, false, "Введите пароль")
    return false
  } else {
    updateValidationState(passwordInput, true)
    return true
  }
}

function updateValidationState(input, isValid, message = "") {
  const feedbackElement = input.nextElementSibling
  if (isValid) {
    input.classList.remove("is-invalid")
    input.classList.add("is-valid")
    feedbackElement.textContent = ""
  } else {
    input.classList.add("is-invalid")
    input.classList.remove("is-valid")
    feedbackElement.textContent = message
  }
}

function enableLoginBtn() {
  loginBtn.removeAttribute('disabled')
  spinner.classList.add('d-none')
}

export function handleLogoutClick(e) {
  let isLogOutClicked = false
  const modalElement = document.getElementById('logoutModal')
  const modal = new Modal(modalElement)
  const onModalHidden = async () => {
    if (!isLogOutClicked) return
    try {
      const result = await signOutUser()
      console.log(result)
    } catch (error) {
      console.log(`Ошибка при выходе: ${error}`)
    } finally {
      modalElement.removeEventListener('hidden.bs.modal', onModalHidden)
    }
  }
  modalElement.addEventListener('hidden.bs.modal', onModalHidden)
  modal.show()
  function confirmLogout() {
    isLogOutClicked = true
    modal.hide()
  }

  const confirmExitBtn = document.getElementById('confirmExitBtn')
  confirmExitBtn.onclick = confirmLogout
}

export function setPermissions(role) {
  const isEditor = role === map.roles.editor
  toggleReadOnlyState(inputElements, 'input', !isEditor)
  toggleReadOnlyState(tagifyElements, 'tagify', !isEditor)
  toggleReadOnlyState(maskElements, 'mask', !isEditor)
  toggleButtonsVisibility(['save-btn', 'delete-btn', 'addBtn'], isEditor)
  toggleFileButtonsVisibility(isEditor)
}

function toggleReadOnlyState(elements, type, readonly) {
  Object.values(elements).forEach(element => {
    switch (type) {
      case 'input':
        if (element.hasAttribute('contenteditable')) {
          element.setAttribute('contenteditable', !readonly)
        } else {
          if (readonly) {
            element.setAttribute('readonly', 'readonly')
          } else {
            element.removeAttribute('readonly')
          }
        }
        break
      case 'tagify':
        if (element.settings.role.elementId !== map.marks.elementId) {
          element.setReadonly(readonly)
        }
        break

      case 'mask':
        if (readonly) {
          element.iMask.el.input.setAttribute('readonly', 'readonly')
        } else {
          element.iMask.el.input.removeAttribute('readonly')
        }
        break
    }
  })
}

function toggleButtonsVisibility(buttonIds, show) {
  buttonIds.forEach(id => {
    const button = document.getElementById(id)
    if (button) {
      button.classList.toggle('d-none', !show)
    }
  })
}

export function toggleFileButtonsVisibility(show) {
  const fileUploadButtons = document.querySelectorAll('.file-upload')
  const fileDeleteButtons = document.querySelectorAll('.file-delete')

  fileUploadButtons.forEach(button => {
    button.classList.toggle('d-none', !show)
  })

  fileDeleteButtons.forEach(button => {
    button.classList.toggle('d-none', !show)
  })

  const uploadFileButtons = document.querySelectorAll('.upload-file-btn')
  const deleteFileButtons = document.querySelectorAll('.delete-file-btn')

  uploadFileButtons.forEach(button => {
    button.classList.toggle('d-none', !show)
  })

  deleteFileButtons.forEach(button => {
    button.classList.toggle('d-none', !show)
  })

  const generatePreviewBtn = document.getElementById('generate-preview-btn')
  if (generatePreviewBtn) {
    generatePreviewBtn.classList.toggle('d-none', !show)
  }

  const regeneratePageBtn = document.getElementById('regenerate-page-btn')
  if (regeneratePageBtn) {
    regeneratePageBtn.classList.toggle('d-none', !show)
  }

  const importBtn = document.getElementById('supabaseImport')
  if (importBtn) {
    importBtn.classList.toggle('d-none', !show)
  }

  const addRowButtons = document.querySelectorAll('.add-row-btn')
  const removeRowButtons = document.querySelectorAll('.remove-row-btn')

  addRowButtons.forEach(button => {
    button.classList.toggle('d-none', !show)
  })

  removeRowButtons.forEach(button => {
    button.classList.toggle('d-none', !show)
  })
}
